var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var ComputeTask_1;
import { EngineMode } from '@symon-ai/wisepipe-base-pipe';
import { PythonEngineVersion, SparkEngineVersion } from '@symon-ai/wisepipe-python-job-domain';
import { BeforeDeserialized, DateConverter, JSON, JsonConverter, JsonSchemaV2 } from '@symon-ai/wisepipe-serialize';
import { OrgPlan } from '@symon-ai/wisepipe-user';
import { CalculationType } from './baseCalculationRequest';
import './incentivesComposerCalcConfig'; // force import json schema
import { computeTaskSchemaValidation } from '../validations.generated';
export const computeTaskSchema = {
    $id: 'urn:wisepipe-common-computation:ComputeTask',
    type: 'object',
    properties: {
        type: { type: 'string', enum: Object.values(CalculationType) },
        taskID: { type: 'string', minLength: 1 },
        user: { type: 'string', format: 'uuid' },
        userName: { type: 'string' },
        userEmail: { type: 'string' },
        orgID: { type: 'string', format: 'uuid' },
        orgPlan: { type: 'string', enum: Object.values(OrgPlan) },
        mode: { type: 'string', enum: Object.values(EngineMode) },
        objectID: { type: 'string', minLength: 1 },
        runName: { type: 'string' },
        pythonEngineVersion: {
            type: 'string',
            enum: Object.values(PythonEngineVersion)
        },
        sparkEngineVersion: {
            type: 'string',
            enum: Object.values(SparkEngineVersion)
        },
        extras: { type: 'array', items: { type: 'string' }, uniqueItems: true },
        incentivesComposerCalcConfig: { $ref: 'urn:wisepipe-common-computation:IncentivesComposerCalcConfig' },
        triggerDependeeCalc: { type: 'boolean' },
        dependeeAncestors: { type: 'array', items: { type: 'string' }, uniqueItems: true },
        rootTaskID: { type: 'string' },
        rootStart: { type: 'string', format: 'date-time' }
    },
    required: ['user', 'orgID', 'mode', 'objectID', 'taskID']
};
let ComputeTask = ComputeTask_1 = class ComputeTask {
    setDefaults() {
        this.type = CalculationType.STANDARD;
    }
    constructor(taskID, orgID, userID, mode, objectID, orgPlan, type = CalculationType.STANDARD, userName, userEmail, runName, pythonEngineVersion, sparkEngineVersion, extras, incentivesComposerCalcConfig, triggerDependeeCalc, dependeeAncestors, rootTaskID, rootStart) {
        this.taskID = taskID;
        this.orgID = orgID;
        this.user = userID;
        this.userName = userName;
        this.userEmail = userEmail;
        this.orgPlan = orgPlan;
        this.mode = mode;
        this.objectID = objectID;
        this.type = type;
        this.runName = runName;
        this.pythonEngineVersion = pythonEngineVersion;
        this.sparkEngineVersion = sparkEngineVersion;
        this.incentivesComposerCalcConfig = incentivesComposerCalcConfig;
        this.triggerDependeeCalc = triggerDependeeCalc;
        this.dependeeAncestors = dependeeAncestors;
        this.rootTaskID = rootTaskID;
        this.rootStart = rootStart;
        if (extras !== undefined)
            this.extras = extras;
        JSON.validate(this, ComputeTask_1);
    }
    get transient() {
        return this.type === CalculationType.TRANSIENT || this.type === CalculationType.TRANSIENT_PIPE;
    }
};
__decorate([
    JsonConverter(new DateConverter('date-time'))
], ComputeTask.prototype, "rootStart", void 0);
__decorate([
    BeforeDeserialized()
], ComputeTask.prototype, "setDefaults", null);
ComputeTask = ComputeTask_1 = __decorate([
    JsonSchemaV2(computeTaskSchema, computeTaskSchemaValidation)
], ComputeTask);
export { ComputeTask };
//# sourceMappingURL=computeTask.js.map